export default {
  props: {
    shouldShowSkeleton: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
